module.exports = __webpack_public_path__ + "static/media/default-tournament-bg-iron.49ac5e79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tournaments/images/default-tournament-bg-iron.jpg
// module id = 411
// module chunks = 103